import { format } from 'date-fns'

export const dateFormatter = (date: string): string => {
    return Date.parse(date) ? format(new Date(date), 'MMM yyyy') : date
}
